import LeavesComponent from '../components/leaves';

export default function Leaves() {
  return <LeavesComponent />;
}
